import { Box } from "@mui/material";
import styled from "styled-components";

export const ImageUploaderWrapper = styled(Box)`
	width: 100%;
	box-sizing: border-box;

	.image_view {
		width: 300px;
		height: 300px;
		object-fit: contain;
		cursor: pointer;
		border-radius: 10px;
	}
	.border-dashed {
		border: 1px dashed;
		padding: 20px 10px;
		cursor: pointer;
		background: #fff;
		display: flex;
		flex-direction: column;
		align-items: center;
		grid-gap: 20px;
		.icon {
			width: 50px;
			height: 50px;
			color: #888888;
		}
	}
	.image_list_wrapper {
		display: flex;
		flex-flow: row wrap;
		gap: 10px;
		.image img {
			padding: 5px;
			box-sizing: border-box;
			width: 75px;
		}
		.image.selected {
			box-shadow: inset 0 0 3px 1px rgb(119 154 185 / 70%);
			border-radius: 5px;
		}

		${props => props.theme.breakpoints.up("md")} {
			.image:hover {
				transition: all 0.3s linear;
				box-shadow: inset 0 0 2px 1px rgb(119 154 185 / 70%);
				border-radius: 5px;
			}
		}
	}
`;
